import type { League, LeagueDivision } from './season-results';

export const SEASON_FOUR_ID = 'S4';
export const SEASON_FOUR_NAME = 'Season 4';
export const SEASON_FOUR_LEAGUE_ID = 'DFL';
export const SEASON_FOUR_LEAGUE_NAME = 'MF League';
export const SEASON_FOUR_PRESEASON_DATE = '2026-10-25';
export const SEASON_FOUR_START_DATE = '2026-10-26';
export const SEASON_FOUR_PLAYOFF_DATES = ['2026-11-10', '2026-11-11', '2026-11-12', '2026-11-13'] as const;
export const SEASON_FOUR_REGULAR_SEASON_DAYS = 15;
export const SEASON_FOUR_ROUNDS_PER_DAY = 3;
export const SEASON_FOUR_FIRST_KICKOFF_UTC_HOUR = 21; // 4:00 PM Central while CDT is active.
export const SEASON_FOUR_GAMES_PER_KICKOFF_SLOT = 2;
export const SEASON_FOUR_KICKOFF_INTERVAL_MINUTES = 20;
export const SEASON_FOUR_PLAYOFF_TEAMS = 12 as const;

/** Fixed Season 4 field and divisions supplied by league administration. */
export const SEASON_FOUR_DIVISION_MEMBERSHIPS = [
  { name: 'West', teamIds: ['13', '25', '14', '28'] },
  { name: 'South', teamIds: ['26', '22', '29', '30'] },
  { name: 'North', teamIds: ['31', '21', '17', '32'] },
  { name: 'East', teamIds: ['33', '18', '35', '36'] },
] as const;

export const SEASON_FOUR_TEAM_IDS = SEASON_FOUR_DIVISION_MEMBERSHIPS
  .flatMap((division) => [...division.teamIds]);

export function buildSeasonFourLeague(): League {
  const divisions: LeagueDivision[] = SEASON_FOUR_DIVISION_MEMBERSHIPS.map((division, index) => ({
    id: `${SEASON_FOUR_LEAGUE_ID}-D${index + 1}`,
    name: division.name,
    teamIds: [...division.teamIds],
  }));

  return {
    id: SEASON_FOUR_LEAGUE_ID,
    name: SEASON_FOUR_LEAGUE_NAME,
    playoffTeamCount: SEASON_FOUR_PLAYOFF_TEAMS,
    conferences: [{ id: SEASON_FOUR_LEAGUE_ID, name: SEASON_FOUR_LEAGUE_NAME, divisions }],
  };
}
